import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { SendStatusUpdateBySMS } from './SendStatusUpdateBySMS'
import { SendStatusUpdateByEmail } from './SendStatusUpdateByEmail'
export const StatusCommunication = ({ ticket }) => {
  return (

      <ReactBootstrap.Dropdown size="sm">
        <ReactBootstrap.Dropdown.Toggle  size="sm" block variant="dark">
          Send Status Details
        </ReactBootstrap.Dropdown.Toggle>

        <ReactBootstrap.Dropdown.Menu>
          <SendStatusUpdateBySMS ticket={ticket} />
          <SendStatusUpdateByEmail ticket={ticket} />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>

  )
}
